import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
interface CTAButtonProps {
  className?: string;
  variant?: 'scroll' | 'purchase';
}
export function CTAButton({
  className = '',
  variant = 'scroll'
}: CTAButtonProps) {
  const handleClick = () => {
    if (variant === 'purchase') {
      if (window.fbq) {
        window.fbq('track', 'InitiateCheckout', {
          content_name: 'El Código de Identidad 1.0',
          content_type: 'product',
          value: 6.39,
          currency: 'USD',
          num_items: 1
        });
      }
      window.open('https://pay.hotmart.com/J105352876O', '_blank');
    } else {
      const el = document.getElementById('pricing');
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-343">
      <motion.button onClick={handleClick} whileHover={{
      opacity: 0.85
    }} whileTap={{
      scale: 0.98
    }} className="flex items-center justify-center gap-3 w-full max-w-md rounded-lg border-2 border-gold bg-gold px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase cursor-pointer transition-opacity" style={{
      boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
    }} data-id="element-344">
        SÍ, QUIERO ANIQUILAR MI PUNTO CIEGO
        <span className="text-[18px] font-black" data-id="element-345">→</span>
      </motion.button>
      <div className="flex items-center gap-2 mt-4 text-[#555] text-[11px] font-bold tracking-[0.5px] uppercase" data-id="element-346">
        <Lock className="w-3 h-3 text-gold" data-id="element-347" />
        <span data-id="element-348">PAGO 100% SEGURO | ACCESO INSTANTÁNEO</span>
      </div>
    </div>;
}